// What the dish sheet opens with when a line on the pad is edited: its choices, its note, its
// allergy note and a meal's parts. The sheet starts its boxes from these and sends them all
// back as they stand, so a line opened with its choices alone came back with its note and
// allergy note blank, and a meal's parts reset (the bar, Oct 2026). Both pads open it here.
export const sheetInitialFor = (item) => ({
  modifiers: item?.modifiers || [],
  notes: item?.notes || '',
  allergy_notes: item?.allergy_notes || '',
  components: item?.components || [],
  size: item?.size || null,
});
